export default __webpack_public_path__ + "static/media/1617 cutlery side.9421fd59.png";